export const messages = {
  title: {
    id: 'changeEmail.Page.Header',
    defaultMessage: 'Change Your Email Address',
  },
  description: {
    id: 'changeEmail.Description',
    defaultMessage: 'We\'ll use this email if you forget your password.',
  },
  button: {
    id: 'changeEmail.Button',
    defaultMessage: 'Update Email',
  },
  email: {
    id: 'changeEmail.Email',
    defaultMessage: 'Email',
  },
};
